export default "__VITE_ASSET__BWui7BB5__"